import { Grid2x2 } from "lucide-react";
import { useCallback, useState } from "react";
import { useSearchParams } from "react-router";

import { SKUCommand } from "@/components/sku-command";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const SkuDropdownMenu = () => {
  const [open, setOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const templateId = searchParams.get("templateId");

  const handleSelectSKU = useCallback(
    (skuId: string) => {
      const tempParams = new URLSearchParams(searchParams);

      tempParams.delete("page");
      tempParams.set("templateId", skuId);

      setSearchParams(tempParams);
      setOpen(false);
    },
    [searchParams, setSearchParams],
  );

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button variant="outline">
          <Grid2x2 /> SKU ID {templateId && <Badge>{templateId}</Badge>}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        <SKUCommand
          onSelect={handleSelectSKU}
          selectedSKUId={searchParams.get("templateId") || ""}
        />
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
